import { render, staticRenderFns } from "./ColunaAcoes.vue?vue&type=template&id=3aa3ebe5&scoped=true"
import script from "./ColunaAcoes.vue?vue&type=script&lang=js"
export * from "./ColunaAcoes.vue?vue&type=script&lang=js"
import style0 from "./ColunaAcoes.vue?vue&type=style&index=0&id=3aa3ebe5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3ebe5",
  null
  
)

export default component.exports